import { getSearchSuggestions, SuggestionApiParameter } from "@BrasselerSurgical/Services/SuggestionService";
import { CustomSuggestionSectionModel } from "@BrasselerSurgical/Types/SuggestionModel";

import {
    createHandlerChainRunner,
    Handler,
    HasOnSuccess,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";

type Parameter = SuggestionApiParameter & HasOnSuccess<CustomSuggestionSectionModel>;
type Props = {
    apiParameter: SuggestionApiParameter;
    apiResult: CustomSuggestionSectionModel;
};

type HandlerType = Handler<Parameter, Props>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = props.parameter;
};

export const RequestDataFromApi: HandlerType = async props => {
    if (props.apiParameter.searchOnTyping || props.apiParameter.query.length >= 3) {
        props.apiResult = await getSearchSuggestions(props.apiParameter);
    }
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    markSkipOnCompleteIfOnSuccessIsSet(props);
    props.parameter.onSuccess?.(props.apiResult);
};

export const chain = [PopulateApiParameter, RequestDataFromApi, ExecuteOnSuccessCallback];

const getSearchSuggestionsHandler = createHandlerChainRunner(chain, "GetSearchSuggestions");
export default getSearchSuggestionsHandler;
